import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { Container, Stack } from '@fiverr-private/layout_components';
import withContext from '../../../lib/withContext';
import { Nav, NavItem, Layout, NavDivider, JoinLink, Logo, NavIcon } from '../../blocks';
import {
    Search,
    LoginLink,
    LeanLocaleSettingsLink,
    FiverrProNavigation,
    ExploreNavigation,
    CategoriesNavigation,
} from '../../components';
import { GuestBecomeSellerNavItem } from '../../components/GuestBecomeSellerNavItem';
import { useNavIconHiddenProps } from '../../hooks/useNavIconHiddenProps';
import { localeNavWrapper } from './LoggedOutLocaleNavItem.ve.css';

export const LoggedOut = () => {
    const navIconHidden = useNavIconHiddenProps();

    return (
        <Layout mobileWrap>
            <Container hidden={navIconHidden}>
                <NavIcon />
            </Container>
            <Stack gap="4" alignItems="center" marginRight={{ default: '0', sm: 'auto' }}>
                <Logo href={pathfinder('root', {}, { query: { source: 'top_nav' } })} />
                <CategoriesNavigation />
            </Stack>
            <Container minWidth="0px" flex="1" hidden={{ default: true, sm: false }}>
                <Search show />
            </Container>
            <Container width="100%" display={{ default: 'block', sm: 'none' }} order={{ default: 99, sm: 0 }}>
                <Search showAlways />
            </Container>
            <Nav gap="2">
                <NavItem displayFrom="lg">
                    <FiverrProNavigation />
                </NavItem>
                <NavItem displayFrom="lg">
                    <ExploreNavigation />
                </NavItem>
                <NavItem displayFrom="lg">
                    <Container className={localeNavWrapper}>
                        <LeanLocaleSettingsLink />
                    </Container>
                </NavItem>
                <NavItem displayFrom="lg">
                    <GuestBecomeSellerNavItem />
                </NavItem>
                <NavDivider displayFrom="lg" />
                <NavItem displayFrom="lg">
                    <LoginLink />
                </NavItem>
                <NavItem>
                    <JoinLink />
                </NavItem>
            </Nav>
        </Layout>
    );
};

export default withContext(LoggedOut);
